import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Modal } from 'antd';
import '../../../index.scss';
import { customBaseUrl, httpPost } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';

const UploadExcel = ({ showModal, hideModal, title, className }) => {
  const [file, setFile] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return Swal.fire('Warning', 'Please select a file', 'warning');

    showLoader();
    const formdata = new FormData();
    formdata.append('file', file);

    const reqId = new Date().getTime();
    const customerName = 'Bulk Bonus';
    const res = await httpPost(`${customBaseUrl.logUrl}/api/v1/requestlog/create/bulk/${reqId}/${customerName}/BulkExcelBonus`, formdata);

    hideLoader();
    if (res?.status) {
      Swal.fire('Done', res.message, 'success');
      setFile(null);
      hideModal(false);
    } else {
      Swal.fire('Error', res.message, 'error');
    }
  };

  return (
    <Modal
      className={className}
      title={title}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={600}
      footer={null}
    >
      <form className='row g-3' noValidate onSubmit={handleSubmit}>
        <div className='col-10 mt-5 mb-3 mx-auto'>
          <div className='input-group'>
            <input
              type='file'
              className='form-control'
              id='inputGroupFile02'
              onChange={(e) => setFile(e.target.files[0])}
            />
            <label className='input-group-text' htmlFor='inputGroupFile02'>
              Browse
            </label>
          </div>
        </div>

        <div className='col-12 text-center mt-5'>
          <button className='btn btn-primary' type='submit'>
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UploadExcel;
